//Include Both Helper File with needed methods
import { getFirebaseBackend } from "../../../helpers/firebase_helper";
import axios from "axios";

import { jwtDecode } from "jwt-decode";

import { loginSuccess, logoutUserSuccess, apiError, reset_login_flag, selectToken } from './reducer';

import apiUrl, { localPath } from "slices/apiEndpoint";
import { toast } from "sonner";
import api from "Common/api";

export const loginUser = (user: any, history: any,setOtpSent?:any,setOtpSessionId?:any) => async (dispatch: any) => {
  try {
    const response = await api.post(`/login/login`, {
      email: user.email
    });
    const data:any = response
    localStorage.setItem('userEmail', user.email)
if(setOtpSent){
  setOtpSent(true)
  toast.success("Email sent to your email address")
}
if(setOtpSessionId){
  setOtpSessionId(data?.sessionId)
}
    ////console.log(data); // Do something with the data
    return data
  }
  catch (error:any) {
    toast.error(error?.response?.data?.message||error?.message||"User Not Found")
    throw error;
  }
};
export const succefullLogin =(data:any,dispatch:any,navigate:any,setLoginData:any)=>{
  if (data) {
const hostname = window.location.hostname;

    localStorage.setItem("token", data.token);
    localStorage.setItem("authUser", JSON.stringify(data.token));
    if (getDecodeUserType() === "admin" || getDecodeUserType() === "homeowner" || getDecodeUserType() === "real_estate_agent") {
      dispatch(loginSuccess(data));
      if (
      ( getDecodeUserType() === "homeowner" ||getDecodeUserType() === "real_estate_agent")   &&
        !(
          window.location.hostname.includes("relibuild") ||
          window.location.hostname === "localhost"
        )
      ) {
        toast.error("Homeowner login not allowed on this domain");
        return;
      }
      
      const pendingPath = localStorage.getItem("pending_path") || "";
      const isRecommendedPropertiesPath = /^\/recommended-properties(?:\?collection=\d+)?$/.test(pendingPath);
      const isMechanicsLienIntakesPath = pendingPath === "/mechanics-lien-intakes";
      if (
        (getDecodeUserType() === "homeowner" && isRecommendedPropertiesPath) ||
        (getDecodeUserType() === "admin" && isMechanicsLienIntakesPath)
      ) {
        localStorage.removeItem("pending_path");
        navigate(pendingPath);
      } else {
        navigate("/dashboard");
      }
      
   
    }
    else {
      if( hostname.includes("relibuild")){
        toast.error("Only Homeowner login allowed on this domain")
       return
      }
      if(getDecodeUserTermsAccepted()===1){
        dispatch(loginSuccess(data));
        navigate("/pages-profile-settings");
      }else{
        setLoginData(data)
      }
     
    }
    return data
  }
}

export const otpVerification = (user: any, navigate: any,setLoginData:any) => async (dispatch: any) => {
  try {
    const response = await api.post(`/login/verify-otp`, {
      email:localStorage.getItem('userEmail'),
      otp: user.otp,
      sessionId:user.sessionId,
      device: "web",
      loginSource: "relibuild-admin"
    });
    let data = response.data;
    if (data) {
     succefullLogin(data,dispatch,navigate,setLoginData)
    }
  }
   catch (error) {
    dispatch(apiError('One time password is expired or invalid'));
    throw error;
  }
};



export const logoutUser = () => async (dispatch: any) => {
  try {
    localStorage.removeItem("authUser");
    localStorage.removeItem("token");
    localStorage.removeItem("userEmail")
      dispatch(logoutUserSuccess(true));

  } catch (error) {
    dispatch(apiError(error));
  }
};

export const socialLogin = (type: any, history: any) => async (dispatch: any) => {
  try {
    let response;

    if (process.env.REACT_APP_DEFAULTAUTH === "firebase") {
      const fireBaseBackend = getFirebaseBackend();
      response = fireBaseBackend.socialLoginUser(type);
    }
    //  else {
    //   response = postSocialLogin(data);
    // }

    const socialdata = await response;
    if (socialdata) {
      localStorage.setItem("authUser", JSON.stringify(socialdata));
      dispatch(loginSuccess(socialdata));
      history('/dashboard');
    }

  } catch (error) {
    dispatch(apiError(error));
  }
};

export const resetLoginFlag = () => async (dispatch: any) => {
  try {
    const response = dispatch(reset_login_flag());
    return response;
  } catch (error) {
    dispatch(apiError(error));
  }
};

export const isTokenExpire = () => async (dispatch: any) => {
  try {
    const response = await api.post(`/login/check-token`, {
      token:localStorage.getItem('token')
    });
    let data = response.data;
    if (!data) {
      localStorage.removeItem("authUser");
    localStorage.removeItem("token");
      localStorage.removeItem("userEmail")
      window.location.reload()
      dispatch(logoutUserSuccess(true));
    }
   }
  catch (error) {
    dispatch(apiError(error));
  }
};


const getStoredAuthToken = () => {
  const stored = localStorage.getItem("authUser");
  if (!stored) return "";

  try {
    const parsed = JSON.parse(stored);
    return typeof parsed === "string" ? parsed : parsed?.token || "";
  } catch (_error) {
    return stored.replace(/^"|"$/g, "");
  }
};

const getDecodedStoredUser = () => {
  const token = getStoredAuthToken();
  if (!token) return null;

  try {
    return jwtDecode<any>(token);
  } catch (_error) {
    return null;
  }
};

export function getDecodeUserType() {
  const decoded = getDecodedStoredUser();
  return decoded?.userType || decoded?.user_type || "";
}

export function getDecodeUserTermsAccepted() {
  return getDecodedStoredUser()?.user_accepts_term;
}
